module.exports = __webpack_public_path__ + "static/media/Step1Option1.8dc62196.jpg";